/**
 * @generated SignedSource<<1437eb8ddcd1b99de0b299afed914914>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type reportCard_reportsOverviewPage$data = {
  readonly description: string;
  readonly isNotApplicableDesc?: string | null | undefined;
  readonly isNotApplicableReason?: string | null | undefined;
  readonly key: string;
  readonly name: string;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"image_reportsOverviewPage_ReportCardImage" | "reportImage_reportsOverviewPage">;
  readonly " $fragmentType": "reportCard_reportsOverviewPage";
};
export type reportCard_reportsOverviewPage$key = {
  readonly " $data"?: reportCard_reportsOverviewPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"reportCard_reportsOverviewPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMigrateTMPReportsOverviewEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "reportCard_reportsOverviewPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "reportImage_reportsOverviewPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "image_reportsOverviewPage_ReportCardImage"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "name"
      },
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "description"
      },
      "action": "THROW",
      "path": "description"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "url"
      },
      "action": "THROW",
      "path": "url"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "condition": "isMigrateTMPReportsOverviewEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isNotApplicableReason"
        },
        {
          "kind": "ScalarField",
          "name": "isNotApplicableDesc"
        }
      ]
    }
  ],
  "type": "JiraReport"
};

(node as any).hash = "6aa389c95744f9c0e24ffb5ddea80396";

export default node;
